<template>
  <el-dialog
    @close="handleClose"
    :visible.sync="show"
    :close-on-click-modal="false"
    :append-to-body="true"
    :center="true"
    width="530px"
  >
    <div slot="title" class="title">
      <span class="active" @click="toggleLogin(LoginType.Email)">{{ $t("account.passwordLogin") }}</span>
      <span @click="handleQQlogin">QQ</span>
    </div>

    <div class="box">
      <el-form class="form" ref="form" :model="form" :rules="rules">
        <!-- 邮箱登录 -->
        <el-form-item prop="email">
          <el-input
            size="medium"
            v-model="form.email"
            :placeholder="$t('account.emailPlaceholder')"
          >
            <i class="el-icon-user" slot="prepend" />
          </el-input>
        </el-form-item>

        <el-form-item prop="pwd">
          <el-input
            size="medium"
            v-model="form.pwd"
            type="password"
            @keyup.native.enter="handleSubmit"
            :placeholder="$t('account.passwordPlaceholder')"
          >
            <i class="el-icon-lock" slot="prepend" />
          </el-input>
        </el-form-item>
      </el-form>

      <div class="btns">
        <el-button
          type="text"
          size="medium"
          class="forget-btn"
          @click="handleTo('forgetPwd')"
        >
          {{ $t("account.forgetPassword") }}
        </el-button>

        <el-button type="text" size="medium" @click="handleTo('register')">
          {{ $t("account.registerAccount") }}
        </el-button>
      </div>

      <el-button
        type="primary"
        size="medium"
        class="login-btn"
        :loading="loading"
        @click="handleSubmit"
      >
        {{ $t("account.login") }}
      </el-button>

      <p class="err-msg" v-if="errMsg">
        {{ errMsg }}
      </p>
    </div>
  </el-dialog>
</template>

<script>
import { getAccessToken, toLogin, getUrlParams, loginByQQ } from '@/utils/auth'
import { getErrorCode, getDefaultErrorText } from '@/views/login/mixin'

const LoginType = {
  Email: 'email',
}

export default {
  name: 'LoginDialog',
  components: {},

  data() {
    return {
      LoginType,

      errMsg: '',
      show: false,
      loading: false,
      rules: {
        email: [
          {
            required: true,
            message: this.$t('account.emailPlaceholder'),
            trigger: 'blur',
          },
        ],
        pwd: [
          {
            required: true,
            message: this.$t('account.passwordPlaceholder'),
            trigger: 'blur',
          },
        ],
      },
      form: {
        email: '',
        pwd: '',
      },

      loginType: LoginType.Email,
    }
  },

  async created() {
    const { path } = getUrlParams()
    const code = getAccessToken()
    if (code) {
      await loginByQQ({ code })
      history.replaceState(null, '', `${location.origin}${path}`)
      this.afterLogin()
    }
  },

  methods: {
    open() {
      this.show = true
    },

    handleClose() {
      this.$store.commit('login', false)
      this.$refs.form && this.$refs.form.resetFields()
      this.show = false
    },

    toggleLogin(type) {
      this.loginType = type
      this.$refs.form && this.$refs.form.resetFields()
    },

    handleQQlogin() {
      toLogin()
    },

    handleTo(name) {
      this.handleClose()
      this.$router.push({ name })
    },

    handleShowUserAgreement() {
      this.showAgreeType = 'agreement'
      this.showAgree = true
    },
    handleShowPrivacy() {
      this.showAgreeType = 'privacy'
      this.showAgree = true
    },

    handleAgreeClose() {
      this.showAgree = false
    },

    // 验证表单字段promise化
    validateField(field) {
      return new Promise((resolve, reject) => {
        this.$refs.form.validateField(field, (err) => {
          if (err) {
            reject(err)
          } else {
            resolve()
          }
        })
      })
    },

    handleEmailLogin() {
      return this.$store.dispatch('LoginEmail', {
        email: this.form.email,
        password: this.form.pwd,
      })
    },

    async handleSubmit() {
      try {
        await this.$refs.form.validate()
      } catch (e) {
        return
      }
      this.errMsg = ''
      this.loading = true

      try {
        const { code } = await this.handleEmailLogin()
        if (code === 200) {
          this.afterLogin()
        } else {
          this.errMsg = getErrorCode()[code]
        }
      } catch (e) {
        console.error(e)
        this.errMsg = getDefaultErrorText()
      }
      this.loading = false
    },

    async afterLogin() {
      this.handleClose()
      this.$store.dispatch('GetNotice')
      await this.$store.dispatch('GetInfo')
      this.$store.dispatch('EnterHome')
    }
  },
}
</script>

<style lang="scss" scoped>
::v-deep {
  .el-dialog__header {
    padding-bottom: 0px;
  }
  .el-form-item__error {
    margin-left: 60px;
  }
}

.box {
  width: 350px;
  margin: 20px auto 10px;
}

.title {
  margin-top: 20px;
  span {
    margin: 0 40px;
    display: inline-block;
    font-size: 15px;
    font-weight: bold;
    cursor: pointer;

    &:hover {
      color: #409eff;
    }

    &.active {
      color: #409eff;
      &::after {
        margin: 10px auto -2px;
        display: block;
        content: "";
        width: 20px;
        height: 3px;
        border-radius: 1px;
        background-color: #409eff;
      }
    }
  }
}

.err-msg {
  margin-top: 6px;
  font-size: 12px;
  color: #f56c6c;
  text-align: center;
}

.agreement-wrapper {
  text-align: center;
  font-size: 13px;
  color: #666;
  font-weight: bold;

  /deep/ .el-button + .el-button {
    margin-left: 5px;
  }
}

.login-btn {
  width: 100%;
  margin-top: 10px;
  margin-bottom: 20px;
}

.forget-btn {
  margin-right: 10px;
}

.btns {
  text-align: right;
}
</style>
